<template>
  <div
    v-if="activeDialog"
    class="overlay"
    :class="activeDialog ? 'active': ''"
  >
    <div
      id="dialoge_close"
      class="common-dialog-wrapper"
    >
      <div class="close-dialog" @click="closePopups">
        <WhiteCloseIcon28 />
      </div>
      <h2 class="dialog-message-title">
        Metadata
      </h2>
      <div class="table-wrapper">
        <table v-if="fileMetadata" ref="metadataTable">
          <thead>
            <tr class="metadata-title-wrapper">
              <th colspan="2" class="table-title">
                Attachment data
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>File name</th>
              <td>{{ fileMetadata.name || '-' }}</td>
            </tr>
            <tr>
              <th>File type</th>
              <td>{{ fileMetadata.type || '-' }}</td>
            </tr>
            <tr>
              <th>File size</th>
              <td>{{ fileMetadata.size || '-' }}</td>
            </tr>
            <tr>
              <th>Original file name</th>
              <td>{{ fileMetadata.originalName || '-' }}</td>
            </tr>
            <tr>
              <th>Original path</th>
              <td>{{ fileMetadata.originalPath || '-' }}</td>
            </tr>
            <tr>
              <th>Modification time</th>
              <td>{{ fileMetadata.modificationTime || '-' }}</td>
            </tr>
            <tr>
              <th>Text version</th>
              <td>{{ fileMetadata.textVersion || '-' }}</td>
            </tr>
          </tbody>
          <thead>
            <tr class="metadata-title-wrapper">
              <th colspan="2" class="table-title">
                Exif data
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="fileMetadata.exifData">
              <th>-</th>
              <td />
            </tr>
            <tr
              v-for="(item, index) in fileMetadata.exifData"
              :key="index"
            >
              <th>{{ item.key }}</th>
              <td>{{ item.value || '-' }}</td>
            </tr>
          </tbody>
          <thead>
            <tr class="metadata-title-wrapper">
              <th colspan="2" class="table-title">
                Timestamps
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Extraction time</th>
              <td>
                {{
                  fileMetadata.startedAt && fileMetadata.finishedAt
                    ? fileMetadata.startedAt + ' ' + fileMetadata.finishedAt
                    : '-'
                }}
              </td>
            </tr>
          </tbody>
          <thead>
            <tr class="metadata-title-wrapper">
              <th colspan="2" class="table-title">
                Optional data
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="fileMetadata.optionalData.length === 0">
              <th>-</th>
              <td />
            </tr>
            <tr
              v-for="(item, idx) in fileMetadata.optionalData.data"
              :key="idx"
            >
              <th>{{ item.key }}</th>
              <td>{{ item.value || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="btn-wrapper">
        <button
          id="dialoge_copy"
          class="btn dialog-btn copy-btn"
          @click="copyMetadata"
        >
          <span class="dialog-btn-text">Copy data</span>
          <transition name="fade" mode="out-in">
            <span v-if="showTooltip" class="tooltip">Copied</span>
          </transition>
        </button>
        <button
          id="dialoge_copy"
          class="btn dialog-btn export-btn"
          @click="exportFile"
        >
          <span class="dialog-btn-text">Export data</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from '@/mixins/debounce';
import WhiteCloseIcon28 from '@/components/icons/WhiteCloseIcon28.vue';

export default {
  name: 'MetadataPopup',
  components: {WhiteCloseIcon28},
  mixins: [debounce],
  props: {
    fileMetadata: {
      type: Object,
      default: () => {
      },
    }
  },
  emits: ['closed'],
  data() {
    return {
      activeDialog: false,
      showTooltip: false,
    };
  },
  methods: {
    openPopups() {
      this.activeDialog = true;
    },
    closePopups() {
      this.activeDialog = false;
      this.$emit('closed');
    },
    copyMetadata() {
      if (this.$refs.metadataTable && this.$refs.metadataTable.innerText) {
        const metadataText = this.$refs.metadataTable.innerText;
        navigator.clipboard.writeText(metadataText);
        this.showTooltip = true;
        this.debounce(() => this.showTooltip = false, 1000);
      }
    },
    exportFile() {
      window.open(this.fileMetadata.link, '_blank', 'download');
    },
  }
};
</script>

<style scoped>
@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.overlay.active {
  animation: show .3s linear;
}

.common-dialog-wrapper {
  width: 100%;
  max-width: 656px;
  border: 1px solid #D7DCE6;
  box-sizing: border-box;
  border-radius: 30px;
  padding: 40px 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
}

.close-dialog {
  width: 70px;
  height: 70px;
  padding: 23px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.close-dialog svg {
  width: 100%;
  height: 100%;
}

.close-dialog svg path {
  transition: .5s all;
}

.close-dialog:hover svg path {
  fill: var(--accent-color);
}

.close-dialog img {
  display: block;
  width: 100%;
}

.common-dialog-wrapper .dialog-btn {
  min-width: 140px;
  width: 100%;
  max-width: 140px;
  padding: 13px 12px;
  background-color: var(--white-color);
  border-color: var(--accent-color);
}

.common-dialog-wrapper .dialog-btn:hover {
  background-color: var(--accent-color);
  border-color: var(--accent-color);
}

.common-dialog-wrapper .dialog-btn:hover .dialog-btn-text {
  color: var(--white-color);
}

.dialog-btn-text {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: var(--accent-color);
  transition: .5s all;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
}

/*custom classes */
.common-dialog-wrapper.assign-success {
  width: 100%;
  max-width: 588px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.dialog-message-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 36px;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--black-color);
}

.table-wrapper {
  max-width: 610px;
  width: 100%;
  height: 500px;
  overflow: auto;
  scrollbar-color: var(--background-color) transparent;
  scrollbar-width: thin;
  padding: 0 15px;
}

.metadata-title-wrapper {
  width: 100%;
  height: 50px;
  border-radius: 5px;
  background: var(--gray-bg-color-2);
}

.table-title {
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--secondary-text-color);
  text-transform: uppercase;
  padding: 18px 24px;
}

.metadata-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px 32px 24px;
}

.list-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 5px;
  white-space: pre;
}

.list-item span {
  display: inline-block;
  white-space: pre;
}

.btn-wrapper {
  display: flex;
  gap: 32px;
  align-items: center;
}

.dialog-btn {
  max-width: 265px;
  min-width: 265px;
  width: 100%;
  height: 48px;
  border-radius: 25px;
}

.export-btn {
  background-color: var(--accent-color);
  border-color: var(--accent-color);
}

.export-btn .dialog-btn-text {
  color: var(--accent-color);
}

.export-btn:hover {
  background-color: var(--white-color);
  border-color: var(--accent-color);
}

.export-btn:hover .dialog-btn-text {
  color: var(--accent-color);
}

.tooltip {
  all: unset;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.75);
  color: #fff;
  z-index: 2000;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  transform: translate(100%, -100%);
  white-space: nowrap;
  transition: all .5s;
}

.copy-btn {
  position: relative;
}

tbody tr th,
tbody tr td {
  padding: 15px 24px 0;
}

tbody tr:last-child th,
tbody tr:last-child td {
  padding: 15px 24px 15px;
}

th {
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--secondary-black-color);
}

td {
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-align: right;
  color: var(--secondary-text-color);
}
</style>
